/**
 * The SVG patterns the kit refers to by id.
 *
 * Mounted once, near the root, rather than inside every chart: pattern ids are
 * document-global, so N charts would each define `c-chart-hatch-4` and the last
 * one mounted would win for all of them. Rendering them once removes the
 * question entirely.
 *
 * Hatching is the third redundancy channel for stacked segments beyond the
 * third — see `seriesHatch`. Only 4, 5 and 6 get one; hatching everything is
 * noise, and the first three are already far enough apart in hue and lightness
 * to stand on their own.
 */
export function ChartDefs() {
  return (
    <svg className="c-chart-defs" aria-hidden="true" focusable="false">
      <defs>
        {/* Diagonal, back-diagonal, dotted — three directions rather than three
            densities, because density reads as intensity, which this is not. */}
        <pattern
          id="c-chart-hatch-4"
          width="6"
          height="6"
          patternUnits="userSpaceOnUse"
          patternTransform="rotate(45)"
        >
          <line x1="0" y1="0" x2="0" y2="6" className="c-chart-defs__stroke" />
        </pattern>
        <pattern
          id="c-chart-hatch-5"
          width="6"
          height="6"
          patternUnits="userSpaceOnUse"
          patternTransform="rotate(-45)"
        >
          <line x1="0" y1="0" x2="0" y2="6" className="c-chart-defs__stroke" />
        </pattern>
        <pattern id="c-chart-hatch-6" width="5" height="5" patternUnits="userSpaceOnUse">
          <circle cx="1.5" cy="1.5" r="1" className="c-chart-defs__dot" />
        </pattern>
      </defs>
    </svg>
  );
}
